import React from 'react';
import { SimulatorModel } from '../models/SimulatorModel';
import { CustomerAddress } from '../models/superbit-api-models';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import { AutocompleteData, IDNameDescriptionDictionary } from '../models/Site';

type Props = {
    CustomerAddress: CustomerAddress;
    addressChange?: Function;
    addressError?: boolean;
    showAdditionDetails?: boolean;
    rows?: number;
};

type State = {
    allCities: any[];
    streetList: any[];
    citiesAutocomplete: Array<AutocompleteData>;
    streetAutocomplete: Array<AutocompleteData>;
    CustomerAddress: any;
    floors: IDNameDescriptionDictionary;
    rows: number;
};

export class Address extends React.Component<Props> {
    private simulatorModel: SimulatorModel;

    state: State = {
        allCities: [],
        streetList: [],
        citiesAutocomplete: [],
        streetAutocomplete: [],
        CustomerAddress: this.props.CustomerAddress,
        floors: {},
        rows: this.props.rows ?? 1
    };

    constructor(props: Props) {
        super(props);
        this.simulatorModel = new SimulatorModel();
        this.state.CustomerAddress = props.CustomerAddress;
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.CustomerAddress !== this.props.CustomerAddress) {
            this.setState({ CustomerAddress: this.props.CustomerAddress });
        }
    }

    onCityInputChange = async (e: any) => {
        const cityString = e.target.value;
        const allCities = this.state.allCities;
        const city = allCities.find((c) => c.value === cityString);

        const address = new CustomerAddress();
        address.city = cityString;
        address.street = undefined;
        address.houseNumber = undefined;
        address.apartmentNumber = undefined;
        address.floor = undefined;
        address.postalCode = undefined;
        address.mailbox = undefined;

        if (city) {
            const streetAutocomplete = await this.simulatorModel.getStreetsAutocomplete(city.value);
            this.setState({ streetList: streetAutocomplete });

           
        }

        this.setState({ CustomerAddress: address });
        
    };

    onStreetInputChange = (e: any) => {
        const streetString = e.target.value;
        const allStreets = this.state.streetList;
        const street = allStreets.find((c: any) => c.value === streetString);

        const address = { ...this.state.CustomerAddress, street: streetString };
        this.setState({ CustomerAddress: address });

        
    };

    findPostalCode = async () => {
        if (this.state.CustomerAddress != null) {
            var data = await new SimulatorModel().getPostalCode(this.state.CustomerAddress.city, this.state.CustomerAddress.street, this.state.CustomerAddress.houseNumber, this.state.CustomerAddress.entry, this.state.CustomerAddress.mailbox);
            console.log('findPostalCode-data', data)
            if (data) {
                let address = { ...this.state.CustomerAddress, postalCode: data.postalCode };
                this.setState({ CustomerAddress: address });
                if (this.props.addressChange) this.props.addressChange(address);
            }
            else {
                let address = { ...this.state.CustomerAddress, postalCode: "" };
                this.setState({ CustomerAddress: address });
                if (this.props.addressChange) this.props.addressChange(address);
            }
        }

    }

    setStateData = async (name: string, value: any) => {
        const address = { ...this.state.CustomerAddress, [name]: value };
        this.setState({ CustomerAddress: address });

        
        if (this.props.addressChange) this.props.addressChange(address);
        this.findPostalCode();
        
    };

    async load() {
        const cities = await this.simulatorModel.getCitiesAutocomplete();
        cities.sort((a: any, b: any) => (a.text > b.text ? 1 : -1));

        const floors = {
            a: { id: -1, name: "בחר", description: "בחר" },
            b: { id: 0, name: "קומת קרקע", description: "קומת קרקע" },
            c: { id: 1, name: "קומת ביניים", description: "קומת ביניים" },
            d: { id: 2, name: "קומת גג", description: "קומת גג" },
            e: { id: 3, name: "פנטהאוז", description: "פנטהאוז" }
        };

        this.setState({
            allCities: cities,
            streetList: [],
            citiesAutocomplete: cities,
            streetAutocomplete: [],
            floors
        });
    }

    componentDidMount() {
        this.load();
    }

    // -------------------------
    // ROW SPLITTING FUNCTION
    // -------------------------
    chunkArray<T>(arr: T[], numChunks: number): T[][] {
        const chunks: T[][] = [];
        const perRow = Math.ceil(arr.length / numChunks);

        for (let i = 0; i < arr.length; i += perRow) {
            chunks.push(arr.slice(i, i + perRow));
        }
        return chunks;
    }

    render() {
        const hide = this.props.showAdditionDetails !== undefined && !this.props.showAdditionDetails;

        // ---------------------------------------
        // ALL INPUT BLOCKS AS ITEMS ARRAY
        // ---------------------------------------
        const items = [

            // --- CITY ---
            <div className="parameter-item" key="city">
                <div className="field">
                    <div className="title">עיר</div>
                    <div className="value">
                        <input type='text'
                            list="city_list"
                            onChange={this.onCityInputChange}
                            value={this.state.CustomerAddress.city ?? ""}
                        />
                        <datalist id="city_list">
                            {this.state.allCities.map((o, i) =>
                                <option key={i} value={o.value}>{o.text}</option>
                            )}
                        </datalist>
                    </div>
                </div>
            </div>,

            // --- STREET ---
            <div className="parameter-item" key="street">
                <div className="field">
                    <div className="title">רחוב</div>
                    <div className="value">
                        <input type='text'
                            list="street_list"
                            onChange={this.onStreetInputChange}
                            value={this.state.CustomerAddress.street ?? ""}
                        />
                        <datalist id="street_list">
                            {this.state.streetList.map((o: any, i) =>
                                <option key={i} value={o.value}>{o.text}</option>
                            )}
                        </datalist>
                    </div>
                </div>
            </div>,

            // --- HOUSE NUMBER ---
            <div className="parameter-item" key="house">
                <div className="field">
                    <div className="title">מס בית</div>
                    <div className="value">
                        <input type="text"
                            value={this.state.CustomerAddress.houseNumber ?? ""}
                            onChange={(e: any) => this.setStateData("houseNumber", e.target.value)}
                        />
                    </div>
                </div>
            </div>,

            // --- ENTRY ---
            <div className="parameter-item" key="entry">
                <div className="field">
                    <div className="title">כניסה</div>
                    <div className="value">
                        <input type="text"
                            value={this.state.CustomerAddress.entry ?? ""}
                            onChange={(e: any) => this.setStateData("entry", e.target.value)}
                        />
                    </div>
                </div>
            </div>,

            // --- MAILBOX ---
            <div className="parameter-item" key="mailbox">
                <div className="field">
                    <div className="title">ת.ד.</div>
                    <div className="value">
                        <input type="text"
                            value={this.state.CustomerAddress.mailbox ?? ""}
                            onChange={(e: any) => this.setStateData("mailbox", e.target.value)}
                        />
                    </div>
                </div>
            </div>,

            // --- APARTMENT NUMBER ---
            <div className={hide ? "hide parameter-item" : "parameter-item"} key="apt">
                <div className="field">
                    <div className="title">מס דירה</div>
                    <div className="value">
                        <input type="text"
                            value={this.state.CustomerAddress.apartmentNumber ?? ""}
                            onChange={(e: any) => this.setStateData("apartmentNumber", e.target.value)}
                        />
                    </div>
                </div>
            </div>,

            // --- FLOOR ---
            <div className={hide ? "hide parameter-item" : "parameter-item"} key="floor">
                <div className="field">
                    <div className="title">קומה</div>
                    <div className="value">
                        <IDNameDescriptionItemSelect
                            OnChange={this.setStateData}
                            Id={"floor"}
                            Options={this.state.floors}
                            Value={this.state.CustomerAddress.floor ?? ""}
                        />
                    </div>
                </div>
            </div>,

            // --- POSTAL CODE ---
            <div className={hide ? "hide parameter-item" : "parameter-item"} key="postal">
                <div className="field">
                    <div className="title">מיקוד</div>
                    <div className="value">
                        <input type="text"
                            value={this.state.CustomerAddress.postalCode ?? ""}
                            onChange={(e: any) => this.setStateData("postalCode", e.target.value)}
                        />
                    </div>
                </div>
            </div>
        ];

        // ---------------------------------------
        // SPLIT ITEMS INTO ROWS
        // ---------------------------------------
        const rows = this.chunkArray(items, this.state.rows);

        return (
            <>
                {rows.map((rowItems, idx) => (
                    <div className="parameter-row address-row" key={idx}>
                        {rowItems}
                    </div>
                ))}
            </>
        );
    }
}

export default Address;
